var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"steps-component"},[_c('ul',{staticClass:"steps is-vertical"},_vm._l((_vm.steps),function(step,key){return _c('li',{key:key,staticClass:"steps-segment",class:{
        'is-active': step.isActive
      }},[_c('item',{attrs:{"name":step.name,"price":step.price,"unit":step.unit,"fullWidth":_vm.fullWidth}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }